import { LogOut } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { BrandLogo } from './BrandLogo';
import { Button } from './ui/Button';

export function AppShell({ children }: { children: React.ReactNode }) {
  const { signOut } = useAuth();

  return (
    <main className="min-h-screen bg-bone text-ink">
      <header className="relative z-30 border-b border-ink/10 bg-ivory/95 backdrop-blur">
        <div className="mx-auto flex min-h-20 w-full max-w-7xl items-center justify-between gap-2 px-4 sm:gap-4 sm:px-6">
          <div className="flex items-center gap-2 sm:gap-7">
            <Link to="/dashboard" className="block p-1" aria-label="Storyly dashboard">
              <BrandLogo variant="mark" className="h-11" />
            </Link>
            <nav aria-label="Workspace" className="flex items-center gap-1">
              <NavLink to="/dashboard" className={({ isActive }) => `rounded-sm px-2 py-2 text-sm font-semibold sm:px-3 ${isActive ? 'bg-ink text-ivory' : 'text-ink/70 hover:bg-ink/5 hover:text-ink'}`}>Galleries</NavLink>
              <NavLink to="/bookings" className={({ isActive }) => `rounded-sm px-2 py-2 text-sm font-semibold sm:px-3 ${isActive ? 'bg-ink text-ivory' : 'text-ink/70 hover:bg-ink/5 hover:text-ink'}`}>Bookings</NavLink>
              <NavLink to="/settings" className={({ isActive }) => `rounded-sm px-2 py-2 text-sm font-semibold sm:px-3 ${isActive ? 'bg-ink text-ivory' : 'text-ink/70 hover:bg-ink/5 hover:text-ink'}`}>Settings</NavLink>
            </nav>
          </div>
          <Button variant="ghost" className="px-0 md:px-5" aria-label="Sign out" onClick={() => void signOut()}>
            <LogOut className="h-4 w-4" />
            <span className="hidden md:inline">Sign out</span>
          </Button>
        </div>
      </header>
      <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:py-10">{children}</div>
    </main>
  );
}
